<ng-template #commonFilters>
  <tr><td>Issuer</td><td>{{query.issuer ? getIssuer(query.issuer) : 'All'}}</td></tr>
  <!-- <tr *ngIf="!search.noninvoiced"><td>Customer</td><td>{{query.customer ? getBusinessName(query.customer) : 'All'}}</td></tr> -->
  <tr><td>Customer(s)</td><td>{{query.customers?.length ? getBusinessNames(query.customers) : 'All'}}</td></tr>
  <tr><td>Area sales manager</td><td>{{query.manager ? getUserName(query.manager) : 'All'}}</td></tr>
  <tr><td>Finished products</td><td style="white-space:pre-wrap">{{finishedProductNames}}</td></tr>
  <!-- <tr><td>Finished product</td><td>{{query.finishedProduct?.calcName || 'All'}}</td></tr> -->
  <tr><td>Country</td><td>{{query.country || 'All'}}</td></tr>
  <tr *ngIf="search.noninvoiced"><td>Trial</td><td>{{query.trial?.trial || 'All'}}</td></tr>
  <!-- <tr *ngIf="!search.noninvoiced"><td>Business unit</td><td>{{query.businessUnit ? getBusinessUnitName(query.businessUnit) : 'All'}}</td></tr> -->
  <tr><td>Business unit(s)</td><td>{{query.businessUnits?.length ? getBusinessUnitNames(query.businessUnits) : 'All'}}</td></tr>
  <tr><td>Sample request</td><td>{{+query.sampleRequest === 2 ? 'SR Only' : (+query.sampleRequest === 3 ? 'no SR' : 'All')}}</td></tr>
</ng-template>

<ng-template #legend let-legend let-col2="col2">
  <div style="position:absolute;right:1em;bottom:0.6em;width:30rem;text-align:right;">
    <table *ngIf="legend" style="white-space:pre;text-align:left;display:inline-block">
      <tr>
        <td style="vertical-align:top">{{legend}}</td>
        <td *ngIf="col2" style="vertical-align:top">{{col2}}</td>
      </tr>
    </table>
    <div *ngIf="!warehousingPopup">Issued by: {{user?.name}}</div>
  </div>
</ng-template>

<ng-container *ngIf="!showDocumentPreview && !silent">

  <div #scrollbox class="scrollbox" [ngStyle]="warehousing && {'height':'calc(100vh - 103px)','overflow':'auto'}" (scroll)="onScroll($event)">

    <div #container id="report-pdf" class="container" *ngIf="pdfSidebar && getType() === 'inventory'" [ngClass]="query?.orientation">
      <div class="logo hidden"><img src="../../../../assets/images/logo_header.svg"/></div>
      <ng-container [ngTemplateOutlet]="inventory"></ng-container>
    </div>

    <div #container id="report-pdf" class="container" *ngIf="pdfSidebar && getType() !== 'inventory'" [ngClass]="query?.orientation" [ngStyle]="getStyle()">

      <div *ngIf="!noheader && !warehousingPopup" class="logo hidden"><img src="../../../../assets/images/logo_header.svg" *ngIf="!dashboard"/></div>

      <div *ngIf="extraTitle" style="text-align:center;font-size:2rem;padding-bottom:2rem">{{extraTitle}}</div>

      <div *ngIf="query?.sampleRequest == 2 && !dashboard" style="font-size:larger">Sample request<br><br></div>

      <!-- FILTER HEADER -->
      <div *ngIf="dashboard">
        <h5 *ngIf="search.offers != null">{{headerText}}Offers</h5>
        <h5 *ngIf="search.orders != null && !isPopup">{{headerText}}Orders</h5>
        <h5 class="section-title" *ngIf="search.orders != null && isPopup">{{pdfData[0]?.recipient}} - {{pdfData[0]?.code}} - {{pdfData[0]?.customerDocumentNumber}}</h5>
        <h5 *ngIf="search.noninvoiced && !search.noninvoiced.projectOverview">{{headerText}}Non invoiced order confirmations {{+query.sampleRequest == 2 ? '(Sample requests)' : ''}}</h5>
        <h5 *ngIf="search.noninvoiced?.projectOverview">{{headerText}}Project Overview {{+query.sampleRequest == 2 ? '(Sample requests)' : ''}}</h5>
        <h5 *ngIf="search.openspo != null">{{headerText}}Open (PF)SPOs</h5>
        <h5 *ngIf="search.dueinvoices != null">{{headerText}}Due invoices</h5>
        <h5 *ngIf="search.lastinvoices != null">{{headerText}}Invoices {{+query.sampleRequest == 2 ? '(Sample requests)' : ''}}</h5>
      </div>

      <div *ngIf="query" class="filter">

        <!-- offers -->
        <div *ngIf="search.offers != null">
          <h5 *ngIf="!dashboard">{{headerText}}Offers</h5>
          <div style="position:relative">
            <table>
              <ng-container *ngTemplateOutlet="commonFilters"></ng-container>
              <tr><td>Offer status</td><td>{{getOfferStatus(query.offerStatus)}}</td></tr>
              <tr><td>Issue date from</td><td>{{formatDate(query.dateFrom)}}</td></tr>
              <tr><td>Issue date to</td><td>{{formatDate(query.dateTo)}}</td></tr>
            </table>
          </div>
        </div>

        <!-- orders -->
        <div *ngIf="!isPopup && search.orders != null">
          <h5 *ngIf="!dashboard">{{headerText}}Orders</h5>
          <div style="position:relative">
            <table>
              <ng-container *ngTemplateOutlet="commonFilters"></ng-container>
              <tr *ngIf="query?.orderNumberVersioned"><td>Order</td><td>{{query.orderNumberVersioned}}</td></tr>
              <tr><td>PO date from</td><td>{{formatDate(query.dateFrom)}}</td></tr>
              <tr><td>PO date to</td><td>{{formatDate(query.dateTo)}}</td></tr>
            </table>
            <ng-container><!-- *ngIf="query.relatedOcs > 1">-->
              <ng-container *ngTemplateOutlet="legend; context: { $implicit: 'Legend:\n\ninvoice status (inv):\nNo IN = not invoiced\nIN ok = invoiced\nPV = The price is outside its validity period\n\n'}"></ng-container>
            </ng-container>
          </div>
        </div>

        <!-- noninvoiced, deliverynotes-->
        <div *ngIf="search.noninvoiced != null || search.deliverynotes || search.deliverStatus">
          <h5 *ngIf="!dashboard && search.noninvoiced && !search.noninvoiced.projectOverview">{{headerText}}Non invoiced order confirmations {{getNonInvoicedBU()}}{{+query.sampleRequest == 2 ? '(Sample requests)' : ''}}</h5>
          <h5 *ngIf="!dashboard && search.noninvoiced && search.noninvoiced.projectOverview">{{headerText}}Project Overview {{getNonInvoicedBU()}}{{+query.sampleRequest == 2 ? '(Sample requests)' : ''}}</h5>
          <h5 *ngIf="!dashboard && !warehousingPopup && search.deliverynotes">{{headerText}}Delivery Notes {{+query.sampleRequest == 2 ? '(Sample requests)' : ''}}</h5>
          <div style="position:relative;min-height:14em">
            <table *ngIf="!warehousingPopup">
              <ng-container *ngTemplateOutlet="commonFilters"></ng-container>
              <tr>
                <td>Unconfirmed dispatch dates</td>
                <td>{{+query.showUnconfirmed === 2 ? 'No' : (+query.showUnconfirmed === 3 ? 'Unconfirmed only' : 'Yes')}}</td>
              </tr>
              <tr><td>Place of loading</td><td>{{query.placeOfLoading ? getBusinessName(query.placeOfLoading) : 'All'}}</td></tr>
              <tr><td>Grouped shipments</td><td style="width:20em">{{query.combinedShipmentMap?.join(', ') || 'All'}}</td></tr>
              <tr><td>Customer name</td><td>{{query.customerReference ? getBusinessName(query.customerReference) : 'All'}}</td></tr>
              <tr><td>Customer reference</td><td>{{query.customerDocumentNumber ? query.customerDocumentNumber : 'All'}}</td></tr>
              <tr><td>Fiscal year</td><td>{{query.fiscalYear ? data.getOptionName(fiscalYearOptions, query.fiscalYear) : 'All'}}</td></tr>
              <tr><td>{{search.deliverynotes ? 'Dispatch' : 'Expected next invoice'}} date from</td><td>{{formatDate(query.dateFrom)}}</td></tr>
              <tr><td>{{search.deliverynotes ? 'Dispatch' : 'Expected next invoice'}} date to</td><td>{{formatDate(query.dateTo)}}</td></tr>
            </table>

            <div *ngIf="warehousingPopup" style="white-space:pre-wrap;margin:2rem;max-width:20rem;">Delivery Address:<br><br>
              <span *ngIf="compilation.type === typeData.get('DN').id" style="line-height:1rem;font-size:1rem">{{compilation.deliveryAddress}}</span>
              <span *ngIf="compilation.type !== typeData.get('DN').id" style="line-height:1rem;font-size:1rem">{{compilation.recipientAddress}}</span>
            </div>

            <!-- <ng-container *ngTemplateOutlet="legend; context: { $implicit: 'Legend:\n! = Accepted delivery date < Dispatch date\n!! = Arrival date vienna < Dispatch date\n!!! = ! and !!\nNC = Dispatch date not confirmed\nPO = Purchase Order position\nPD = Partial delivery\nETA = ETA customer date missing'}"></ng-container> -->
            <!-- <ng-container *ngTemplateOutlet="legend; context: { $implicit: 'Legend:\nNC = Associated PFSPO not confirmed\n! = Customer requested - ETA Customer\n!! = Accepted delivery - ETA customer\nX = Dispatch - Arrival vienna\nDS = Direct shipment\nPD = Partial delivery\nPO = Purchase order position'}"></ng-container> -->
            <!-- <ng-container *ngTemplateOutlet="legend; context: { 
              $implicit: 'Legend:\n\nOC related\n  ! = Customer requested - ETA Customer (days)\n  !! = Accepted delivery - ETA customer\n  AP = Dispatch date < today\n  DS = Direct shipment\nPFSPO Related:\n  X = Dispatch - Arrival vienna\n  NC = Associated PFSPO not confirmed\n\nPO = Purchase order position\nPD = Partial delivery'
            }"></ng-container> -->
            <ng-container *ngTemplateOutlet="legend; context: { 
              $implicit: 'Legend:\n\nOC related\n  CRDD = Customer requested delivery date\n  CADD = Customer accepted delivery date\n  ! = CRDD - ETA Customer (days)\n  !! = CADD - ETA customer\n  AP = Planned next invoice date < today\n  DS = Direct shipment\n  ID<>DD = Invoice date differs from dispatch date\n  PV = The price is outside its validity period\n\n',
              col2: '\n\nPFSPO Related:\n  X = Dispatch - ETA AT\n  NC = Associated PFSPO not confirmed\n\nPO = Purchase order position\nPD = Partial delivery\n\n'
            }"></ng-container>

          </div>
        </div>

        <!-- openspo -->
        <div *ngIf="search.openspo != null">
          <h5 *ngIf="!dashboard">{{headerText}}Open (PF)SPOs</h5>
          <div style="position:relative;display:flex">
            <table class="mask-table">
              <tr><td>Issuer</td><td>{{query.issuer ? getIssuer(query.issuer) : 'All'}}</td></tr>
              <tr><td>Supplier</td><td>{{query.customer ? getBusinessName(query.customer) : 'All'}}</td></tr>
              <tr><td>Type of documents</td><td>{{getSelectedItems(query.docs)}}</td></tr>
              <tr><td>Sample request</td><td>{{+query.sampleRequest === 2 ? 'SR Only' : (+query.sampleRequest === 3 ? 'no SR' : 'All')}}</td></tr>
              <tr><td>Combined shipment</td><td>{{query.combinedShipment ? query.combinedShipment : 'All'}}</td></tr>
              <tr><td>Customer name</td><td>{{query.customerReference ? getBusinessName(query.customerReference) : 'All'}}</td></tr>
              <tr><td>Customer reference</td><td>{{query.customerDocumentNumber ? query.customerDocumentNumber : 'All'}}</td></tr>
              <tr><td>Sort order</td><td>
                {{query.sortType === 1 ? 'EXW date,&nbsp;Means&nbsp;of&nbsp;transport,&nbsp;CS&nbsp;#,&nbsp;PFSPO&nbsp;#' : 
                (query.sortType === 2 ? 'Document #' : 
                (query.sortType === 3 ? 'Dispatch date, Document #' : ''))
              }}
            </table>
            <table class="mask-table">
              <tr><td>{{query.dateField == 1 ? 'EXW' : 'Dispatch'}} date from</td><td>{{formatDate(query.dateFrom)}}</td></tr>
              <tr><td>{{query.dateField == 1 ? 'EXW': 'Dispatch'}} date to</td><td>{{formatDate(query.dateTo)}}</td></tr>
              <tr><td>Transportation</td><td>{{query.meansOfTransport ? query.meansOfTransport : 'All'}}</td></tr>
              <tr><td>SPO status</td><td>{{getSelectedItems(query.spoStatus)}}</td></tr>
              <tr><td>Transport status</td><td>{{getSelectedItems(query.transportStatus)}}</td></tr>
              <tr><td>Finished products</td><td style="white-space:pre-wrap">{{finishedProductNames}}</td></tr>
              <tr><td>OBIC</td><td>{{query.obic ? query.obic : 'All'}}</td></tr>
            </table>
            <!-- <table class="mask-table">
              </td></tr>
            </table> -->
            <table *ngIf="query.allDocs" class="mask-table" style="border-right:none;width:15em">
              <tr><td>Documents without {{query.dateField == 1 ? 'EXW' : 'Dispatch'}} date included</td></tr>
            </table>

            <!-- <ng-container *ngTemplateOutlet="legend; context: { $implicit: 'Legend:\n! = Customer requested - ETA Customer\n!! = Accepted delivery - ETA customer\nX = Dispatch - Arrival vienna\n! and !! are related to OC\n', cols: 2}"></ng-container> -->
            <!-- <ng-container *ngTemplateOutlet="legend; context: { 
              $implicit: 'Legend:\n  PFSPO related:\n    NC = Associated PFSPO not confirmed\n    TS (EXW) = EXW < today and\n        Transport Status = planned\n    TS (ARR) = ARR < today and\n        Transport Status = Planned oder En route',
              col2: '\nOC related:\n  X = Dispatch - ETA AT (days)\n  ! = Customer requested - ETA Customer\n  !! = Accepted delivery - ETA customer\n  AP = Planned next invoice date < today\n  DS = Direct shipment\n  IN = invoiced'
            }"></ng-container> -->
            <ng-container *ngTemplateOutlet="legend; context: { 
              $implicit: 'Legend:\n  PFSPO related:\n    NC = Associated PFSPO not confirmed\n    TS (EXW) = EXW < today and\n        Transport Status = planned\n    TS (ARR) = ARR < today and\n        Transport Status = Planned oder En route',
              col2: '\nOC related:\n  X = Dispatch - ETA AT (days)\n  CRDD = Customer requested delivery date\n  CADD = Customer accepted delivery date\n  ! = CRDD - ETA Customer\n  !! = CADD - ETA customer\n  DS = Direct shipment\n  IN = invoiced'
            }"></ng-container>

          </div>
        </div>

        <!-- dueinvoices -->
        <div *ngIf="search.dueinvoices != null">
          <h5 *ngIf="!dashboard">{{headerText}}Due invoices</h5>
          <div style="position:relative">
            <table>
              <ng-container *ngTemplateOutlet="commonFilters"></ng-container>
              <tr><td>Fiscal year</td><td>{{query.fiscalYear ? data.getOptionName(fiscalYearOptions, query.fiscalYear) : 'All'}}</td></tr>
              <tr><td>Payment status</td><td>{{getPaymentStatus()}}</td></tr>
              <tr><td>Due date from</td><td>{{formatDate(query.dateFrom)}}</td></tr>
              <tr><td>Due date to</td><td>{{formatDate(query.dateTo)}}</td></tr>
            </table>
            <ng-container *ngTemplateOutlet="legend; context: { $implicit: 'Legend:\n\nTC = Test Certificate (not) completed\nPoD = Proof of Delivery (not) completed\nTR = Transaction Receipt (not) completed\nNP = not paid\nPP = partially paid\nFP = fully paid\n! = Requested delivery date - Dispatch date\n!! = ETA AT date - Dispatch date\nFY = Book keeping relevant fiscal year <> Issue date fiscal year\n\n' }"></ng-container>
          </div>
        </div>

        <!-- lastinvoices -->
        <div *ngIf="search.lastinvoices != null">
          <h5 *ngIf="!dashboard">{{headerText}}Invoices {{+query.sampleRequest == 2 ? '(Sample requests)' : ''}}</h5>
          <div style="position:relative">
            <table>
              <ng-container *ngTemplateOutlet="commonFilters"></ng-container>
              <tr><td>Fiscal year</td><td>{{query.fiscalYear ? data.getOptionName(fiscalYearOptions, query.fiscalYear) : 'All'}}</td></tr>
              <tr><td>Documents</td><td>{{getSelectedItems(search.lastinvoices.docs)}}</td></tr>
              <tr><td>Issue date from</td><td>{{formatDate(query.dateFrom)}}</td></tr>
              <tr><td>Issue date to</td><td>{{formatDate(query.dateTo)}}</td></tr>
            </table>
            <ng-container *ngTemplateOutlet="legend; context: { $implicit: 'Legend:\n\nTC = Test Certificate (not) completed\nPoD = Proof of Delivery (not) completed\nTR = Transaction Receipt (not) completed\nNP = not paid\nPP = partially paid\nFP = fully paid\n! = Requested delivery date - Dispatch date\n!! = ETA AT date - Dispatch date\nFY = Book keeping relevant fiscal year <> Issue date fiscal year\n\n' }"></ng-container>
          </div>
        </div>

      </div>


      <!-- loading hint -->
      
      <div class="nodata hidden" *ngIf="pdfData == null || pdfData.length === 0">
        <span *ngIf="!loading">no data available</span>
        <ngx-loading-spinner [loading]="loading"></ngx-loading-spinner>
      </div>


      
      <!-- REPORT -->

      <ng-container *ngIf="pdfData?.length > 0 && !loading">

        <!-- total net / total weight -->

        <ng-container *ngIf="!dashboard && !query.noPrices && !isMachinery()">
          <div *ngIf="search.orders && search.orders.relatedOcs > 1" class="total-net">
            Total net (OR):&nbsp;&nbsp;{{ getOrOcTotalNet()[0]  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}<br>
            Total net (OC):&nbsp;&nbsp;{{ getOrOcTotalNet()[1]  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
            <span *ngIf="search.orders.relatedInvoices > 1"><br>
              Total net (IN):&nbsp;&nbsp;{{ getOrOcTotalNet()[2]  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
            </span>
            <span *ngIf="search.orders.relatedCreditNotes > 1"><br>
              Total net (CN):&nbsp;&nbsp;{{ getOrOcTotalNet()[3]  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
            </span>
            <span *ngIf="search.orders.relatedCreditNotes > 1 && search.orders?.showMarkup > 1"><br><br>
              Total net (IN-CN):&nbsp;&nbsp;{{ getOrOcTotalNet()[2] + getOrOcTotalNet()[3]  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
            </span>
            <span *ngIf="search.orders.relatedSPOs > 1 && search.orders?.showMarkup > 1"><br>
              Total net ((PF)SPO):&nbsp;&nbsp;{{ getOrOcTotalNet()[4]  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
            </span>
            <span *ngIf="search.orders.relatedSPOs > 1 && search.orders?.showMarkup > 1"><br>
              Total net (Markup):&nbsp;&nbsp;{{ getOrOcTotalNet()[2] + getOrOcTotalNet()[3] - getOrOcTotalNet()[4]  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
            </span>
          </div>
          <div *ngIf="!search.orders || search.orders.relatedOcs == 1" class="total-net">
            <ng-container *ngIf="search.dueinvoices">
              <span *ngIf="[1,2].includes(search.dueinvoices.dueStatus)">Total sum due: {{ getDueTotalNet() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'  }}</span><br>
              <span *ngIf="[1,3].includes(search.dueinvoices.dueStatus)">Total sum overdue: {{ getOverdueTotalNet() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'  }}</span><br>
            </ng-container>
            <span *ngIf="!search.dueinvoices || search.dueinvoices.dueStatus === 1">Total net: {{ getTotalNet()  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</span>
            <span *ngIf="getTotalWeight() > 0"><br>Total weight: {{ getTotalWeight() | number : '1.2-2' : 'de' }} kg</span>
            <!-- <div *ngIf="isMachinery()">{{ getTotalNetGross()  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</div>
            <div *ngIf="isMachinery()">{{ getTotalNetProgressPayment()  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</div> -->
          </div>
        </ng-container>

        <div *ngIf="isMachinery()" class="total-net">
          <span>Net total (w/o progress payment): {{ getTotalNetGross()  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</span><br>
          <span>Remaining total (with progress payments): {{ getTotalNet()  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</span>
        </div> 


        <!-- <div *ngIf="warehousing" class="p-2">
          <button class="nrk-button mr-2" (click)="hideDispatched = !hideDispatched">{{hideDispatched ? 'Show' : 'Hide'}} Dispatched</button>
          <button class="nrk-button mr-2" (click)="hideDelivered = !hideDelivered">{{hideDelivered ? 'Show' : 'Hide'}} Delivered</button>
        </div> -->

        <!-- document list -->
        <ng-container *ngFor="let doc of getPdfData(); index as docidx; last as doclast; first as docfirst">

          <!-- FilterCompleted = {{search.noninvoiced?.filterCompletedProjects}} .
          ProjectCompleted (m) = {{doc.projectCompleted}} .
          ProjectCompleted (a) = {{doc.completed}} . -->

          <div *ngIf="!warehousingPopup || compilation.code === doc.code" 
            [style]="warehousing && doc.packingStatus === packingStatus.readyForPacking && !doc.confirmedByWarehousing ? 'border:2px solid #3b3' : null"
          >

            <!-- gap before order in order report -->
            <div *ngIf="search.orders && doc.type === 2 && !isPopup" style="height:1rem"></div>

            <!-- document -->

            <a [href]="'#' + doc.code" [id]="'rep_' + doc.code"></a>
            <div [ngClass]="{'no-page-break': true, 'print-item-section': true, 'break-before': checkPageBreak(docidx, doc)}">

              <div *ngIf="doc.sectionHeader" style="font-size: 1.6rem; line-height:2rem">{{doc.sectionHeader}}</div>

              <div *ngIf="search.dueinvoices && docidx === 0" style="font-size:1.6rem;line-height:2rem">{{checkCurrentOverdue(0)  ? 'Overdue' : 'Due'}} invoices</div>
              <div *ngIf="search.dueinvoices && docidx !== 0 && showSectionTitle(docidx) && checkCurrentOverdue(docidx)" style="font-size:1.6rem;line-height:2rem">Overdue invoices</div>
              <div *ngIf="search.dueinvoices && docidx !== 0 && showOverdueGrace(docidx) && !checkDueOverdueChange(docidx)" style="font-size:1.6rem;line-height:2rem">Overdue grace</div>
              <div *ngIf="search.dueinvoices && docidx > 0 && checkDueOverdueChange(docidx)" style="font-size:1.6rem;line-height:2rem">Due invoices</div>

              <!-- <div *ngIf="search.offers && checkCurrentBusinessStateChange(docidx)" style="font-size:1.6rem;line-height:2rem;margin-top:1rem">{{checkCurrentBusinessStateChange(docidx)}}</div> -->

              <!-- assocaiated (PF)SPOs -->
              <div *ngIf="doc.spos?.length" class="doc-item" style="padding-top:1rem;padding-right:5px">
                <table>
                  <thead class="doc-item-header product-header">
                    <tr>
                      <td style="width:15rem;"></td>
                      <td style="width:5rem">OC #</td>
                      <td style="text-align:center;width:5rem">OC Pos</td>
                      <td style="width:3rem"></td>
                      <td style="width:6rem">(PF)SPO #</td>
                      <td style="text-align:center;width:5rem">Pos</td>
                      <td style="text-align:right;width:2.2rem">Quantity</td>
                      <td style="width:5rem;text-align:right">Price</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let spo of doc.spos">
                      <td style="padding-left:5rem"><i>Associated (PF)SPO:</i></td>
                      <td><a class="doc-num-link" [routerLink]="['/pages/erp/document/' + getValue(doc.oc, 'documentNumber')[2]]" 
                        [queryParams]="{code: getValue(doc.oc, 'documentNumber')[1]}" target="_blank">
                        {{getValue(doc.oc, 'documentNumber')[0]}}
                      </a></td>
                      <td style="text-align:center;width:3rem">{{spo.parentPos + 1}}</td>
                      <!-- <td>{{spo.code + 'VS' + spo.version}}</td> -->
                      <td></td>
                      <td><a class="doc-num-link" [routerLink]="['/pages/erp/document/' + getValue(spo, 'documentNumber')[2]]" 
                        [queryParams]="{code: getValue(spo, 'documentNumber')[1]}" target="_blank">
                        {{getValue(spo, 'documentNumber')[0]}}
                      </a></td>
                      <td style="text-align:center">{{spo.pos}}</td>
                      <td style="text-align:right">{{spo.quantity}}</td>
                      <td *ngIf="spo.doc.currency ==='EUR'" style="text-align:right">
                        {{spo.doc.lineItems[spo.pos - 1].piecePrice * spo.quantity | number : '1.2-2'}} €
                      </td>
                      <td *ngIf="spo.doc.currency !=='EUR'" style="text-align:right; background-color: yellow">
                        <span [attr.title]="spo.doc.lineItems[spo.pos - 1].piecePriceCurrency * spo.quantity | currency : spo.doc.currency : 'symbol' : '1.2-2'">
                          {{spo.doc.lineItems[spo.pos - 1].piecePrice * spo.quantity | number : '1.2-2'}} €
                        </span>
                      </td>
                    </tr>
                    <tr *ngIf="doc.spos?.length > 1" class="product-total"><td colspan="7" style="text-align: right">
                      Spo total:
                    </td><td style="text-align: right">
                      {{getSpoData(docidx).spo | number : '1.2-2'}} €
                    </td></tr>
                    <tr class="product-total" *ngIf="query?.showMarkup > 1"><td colspan="7" style="text-align: right">
                      Markup:
                    </td><td style="text-align: right">
                      {{(getSpoData(docidx).inv - getSpoData(docidx).cn - getSpoData(docidx).spo) | number : '1.2-2'}} €
                    </td></tr>
                  </tbody>
                </table>
              </div>


              <ng-container *ngIf="!doc.spos">
                <!-- section title -->

                <div *ngIf="showSectionTitle(docidx) && !isPopup" class="section-title">{{showSectionTitle(docidx)}}
                  <!-- <span *ngIf="query.sortByManager && showSectionTitle(docidx) && !dashboard">
                    (Total net: {{ getSectionTotal(doc)  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                    <span *ngIf="isMachinery()">;
                      {{ getSectionTotalGross(doc)  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                      {{ getSectionProgressPayment(doc)  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                    </span>)
                  </span> -->
                </div>
                <div *ngIf="showSectionTitle(docidx) && !isPopup && !dashboard && isMachinery()" class="section-total-net" style="margin:0 0 0.5rem 0">
                  Net total (w/o progress payment): {{ getSectionTotalGross(doc)  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}<br>
                  Remaining total (with progress payment): {{ getSectionTotal(doc)  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                </div>
                <div *ngIf="showSectionTitle(docidx) && !dashboard && !isMachinery()" class="section-total-net" style="margin:0 0 0.5rem 0">
                  Total net: {{ getSectionTotal(doc)  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                </div>

                <div *ngIf="showDocTitle(docidx) && this.search.orders && !isPopup" style="height:3em"></div>
                <div *ngIf="showDocTitle(docidx) && !isPopup" class="doc-type" [style.paddingTop]="showSectionTitle(docidx) ? 0 : null">
                  {{showDocTitle(docidx)}}
                </div>
                <div *ngIf="showDocTitleRight(docidx)" style="position:relative;font-size:100%;font-weight:bold">
                  <div *ngIf="!isPopup" class="right" style="position:absolute;right:0.5rem;bottom:0.4rem;text-align:right">
                    <div>
                      <!-- <span style="display:inline-block;width:10rem">{{showDocTitleRight(docidx)[0]}}</span> -->
                      <table style="margin-left:23em">
                        <tr>
                          <td style="vertical-align:bottom">Recipient total net:</td>
                          <td style="vertical-align:bottom;width:7rem">
                            <ng-container *ngFor="let title of showDocTitleRight(docidx).col1">
                              <span><br>{{title}}</span>
                            </ng-container>
                          </td>
                          <td *ngIf="showDocTitleRight(docidx).col2.length" style="vertical-align:bottom;width:8rem">
                            <ng-container *ngFor="let title of showDocTitleRight(docidx).col2">
                              <span><br>{{title}}</span>
                            </ng-container>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <!-- <div *ngIf="isPopup" style="position:absolute;right:0.5rem;bottom:0.4rem;border: 1px solid #ddd;padding: 0.2rem 1rem;">
                    <table>
                      <tr *ngFor="let title of showDocTitleRight(docidx).col1">
                        <td style="text-align:right;font-weight:normal;"><i>{{split(title)[0]}}</i></td>
                        <td style="font-weight:normal;"><i>{{split(title)[1]}}</i></td>
                      </tr>
                      <tr *ngFor="let title of showDocTitleRight(docidx).col2; last as isLast">
                        <td style="text-align:right;font-weight:normal;"><i>{{split(title)[0]}}</i></td>
                        <td style="font-weight:normal;"><i>{{split(title)[1]}}</i></td>
                      </tr>
                    </table>
                  </div> -->
                </div>

                <div *ngIf="isPopup && docfirst" class="or-popup-summary">
                  <div class="or-popup-header">Summary</div>
                  <table>
                    <tr class=" tr-paragraph-bottom">
                      <td></td>
                      <td>Order net:</td>
                      <td>{{ formatSum(getSum(docidx, 'OR')) }}</td>
                    </tr>
                    <tr class="tr-paragraph-top tr-paragraph-bottom">
                      <td></td>
                      <td>Order confirmations net:</td>
                      <td>{{ formatSum(getSum(docidx, 'OC')) }}</td>
                    </tr>
                    <tr class="tr-paragraph-top">
                      <td></td>
                      <td>Invoices net:</td>
                      <td>{{ formatSum(getSum(docidx, 'IN')) }}</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Credit notes net:</td>
                      <td>{{ formatSum(getSum(docidx, 'CN')) }}</td>
                    </tr>
                    <tr class="tr-paragraph-bottom">
                      <td></td>
                      <td>IN-CN net:</td>
                      <td>{{ formatSum(getSum(docidx, 'IN') + getSum(docidx, 'CN')) }}</td>
                    </tr>
                    <tr class="tr-paragraph-top" style="border-top: 1px solid #999;" *ngIf="query.showMarkup > 1">
                      <td></td>
                      <td>PFSPO net:</td>
                      <td>-{{ formatSum(getSum(docidx, '(PF)SPO')) }}</td>
                    </tr>
                    <tr class="tr-paragraph-bottom" style="border-bottom: 1px solid #999;" *ngIf="query.showMarkup > 1">
                      <td></td>
                      <td>Markup:</td>
                      <td>{{ formatSum(getSum(docidx, 'IN') + getSum(docidx, 'CN') - getSum(docidx, '(PF)SPO')) }}</td>
                    </tr>
                    <tr class="tr-paragraph-top tr-paragraph-bottom" *ngIf="query.showMarkup > 1">
                      <td></td>
                      <td>Markup %:</td>
                      <td>{{ (1 - getSum(docidx, '(PF)SPO') / (getSum(docidx, 'IN') + getSum(docidx, 'CN'))) * 100 | number : '1.2-2' : 'de' }} %</td>
                    </tr>
                  </table>
                </div>
      
                <!-- document header -->

                <!-- <div *ngIf="showDocHeader(docidx)" id="doc-header" class="doc-header">
                  <table>
                    <tr>
                      <th style="width:1rem;padding:0"></th>
                      <ng-container *ngFor="let item of getPdfTable().docTable">
                        <th [ngStyle]="{ 'text-align': item.align || 'inherit', width: item.width || 'auto' }">{{item.header}}</th>
                      </ng-container>
                    </tr>
                  </table>
                </div> -->

                <div *ngIf="warehousing || messaging" style="position:relative" class="hidden"> 
                  <div *ngIf="warehousing" class="packing-right">
                    <div *ngIf="doc.placeOfLoading" class="mb-2 ml-3">Place of Loading:<br>{{getBusinessName(doc.placeOfLoading)}}</div>
                    <!-- <div class="packing-status" [ngStyle]="{'background-color': ['#ddd','#fb3c','#0afa','#0c0a'][doc.packingStatus || 0]}">{{['Not Ready for Packing','Ready for Packing','Ready for Dispatch','Dispatched'][doc.packingStatus || 0]}}</div> -->
                    <ngx-dn-status [compilation]="doc"></ngx-dn-status>
                  </div>
                  <div *ngIf="messaging && doc.messages?.length" class="packing-left">
                    <div style="overflow:auto;max-height:11rem">
                      <div *ngFor="let message of doc.messages">
                        <ng-container *ngIf="!message.deleted">
                          <div class="mail-from-to" [ngStyle]="{ 'margin-right': canShowMessage(message) ? '0' : '0.5rem' }" (click)="openMessage(message)">
                            <span>{{getMailFromTo(message)}}</span>&nbsp;<span><i>[{{message.subject}}]</i></span>
                          </div>
                          <div style="display:inline-block">
                            <button *ngIf="canShowMessage(message, true)" [class]="getMessageClass(message)" (click)="openMessage(message)">
                              <nb-icon icon="email-outline"></nb-icon>
                            </button>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- document data -->

                <div class="doc-item" [ngStyle]="getDocStyle(doc, docidx)" *ngIf="getPdfTable()">

                  <!-- link header table -->
                  <div class="float-right print-hidden" *ngIf="!warehousingPopup">
                    <table class="link-header">
                      <tr>
                        <!-- <ng-container *ngFor="let err of doc.errors">
                          <td *ngIf="!err.link" title="{{err.description}}" [ngStyle]="{ 'background-color': err.color ? err.color : '#c33' }">{{err.short}}</td>
                          <td *ngIf="err.link" title="{{err.description}}" [ngStyle]="{ 'background-color': err.color ? err.color : '#c33' }">
                            <a [routerLink]="[]" (click)="api.downloadFile(err.link)">{{err.short}}</a>
                          </td>
                        </ng-container> -->
                        <!-- <td *ngIf="search.noninvoiced && messaging && doc"><a [routerLink]="[]" (click)="internalUpdates.open(doc)">Internal</a></td> -->
                        <td *ngIf="['OC'].includes(typeData.get(doc.type)?.code)"><a [routerLink]="[]" (click)="openDocEditor(doc)">Edit</a></td>
                        <td *ngIf="showInternal(doc)"><a [routerLink]="[]" (click)="internalUpdates.open(doc)">Internal</a></td>
                        <td *ngIf="search.offers && doc" [ngStyle]="{ 'background-color': doc.dontShowInReport ? '#ff8888' : null }"><a [routerLink]="[]" 
                          (click)="toggleShowInReport(doc)">{{doc.dontShowInReport ? 'show in report' : 'don\'t show in report'}}
                        </a></td>
                        <td *ngIf="search.offers && doc"><a [routerLink]="[]" (click)="openOfferSettings(doc)">Offer Settings</a></td>
                        <td *ngIf="messaging"><a [routerLink]="[]" (click)="openMessaging(doc)">Message</a></td>
                        <!-- <td *ngIf="!warehousing && search.noninvoiced"><a [routerLink]="[]" (click)="unlinkSpos(doc)" style="text-decoration: line-through" title="remove SPOs from OC">SPO</a> -->
                        <td *ngIf="!warehousing && search.noninvoiced && auth.user.erpRoles.admin"><a [routerLink]="[]" (click)="removeSpoWindow.open(null, $event)" style="text-decoration: line-through" title="remove SPOs from OC">SPO</a>
                          <nrk-window #removeSpoWindow windowPosition="mouseCenter">
                            <nrk-header>{{doc.code}}</nrk-header>
                            <nrk-content>
                              <div class="p-4 text-center">
                                Are you sure to remove all SPOs<br>
                                and reset all associated boxes?
                              </div>
                            </nrk-content>
                            <nrk-footer>
                              <div class="text-center">
                                <button class="nrk-button m-2" (click)="unlinkSpos(doc);removeSpoWindow.close()">Remove</button>
                                <button class="nrk-button m-2" (click)="removeSpoWindow.close()">Cancel</button>
                              </div>
                            </nrk-footer>
                          </nrk-window>
                        </td>
                        <td *ngIf="!warehousing || +doc?.packingStatus > 0"><a [routerLink]="[]" (click)="pdfPreview(doc)">{{warehousing ? 'Edit' : 'Document'}}</a></td>
                        <td *ngIf="!warehousing && (compilation?.type != 5 || compilation?.draft)"><a [routerLink]="[]" (click)="downloadDocPdf(doc)">PDF</a></td>
                        <td *ngIf="!warehousing && (compilation?.type == 5 && !compilation?.draft)"><a [routerLink]="[]" (click)="downloadDocPdf(doc, false, true)">PDF</a></td>
                        <td *ngIf="!warehousing"><a [routerLink]="[]" (click)="downloadDocPdf(doc, true, false, true, true)">ZIP</a></td>
                        <td *ngIf="!warehousing && compilation?.proveOfDelivery"><a [routerLink]="[]" (click)="download(compilation.proveOfDelivery)">PoD</a></td>
                        <td *ngIf="['IN','PFIN'].includes(typeData.get(doc.type).code)"><a [routerLink]="[]" (click)="currentDueInfoCode=doc.code;dueInfoWin.open()">Due Info</a></td>
                      </tr>
                    </table>
                  </div>
                  <!-- error header table -->
                  <table class="error-header">
                    <tr>
                      <ng-container *ngFor="let err of doc.errors">
                        <td *ngIf="!err.link && !err.download" title="{{err.description}}" [ngStyle]="{ 'background-color': err.color || '#c33', 'color': err.textColor || 'white', 'font-weight': err.fontWeight || 'bold' }">{{err.short}}</td>
                        <td *ngIf="err.download" title="{{err.description}}" [ngStyle]="{ 'background-color': err.color || '#c33' }">
                          <a [routerLink]="[]" [ngStyle]="{ 'font-weight': err.fontWeight || 'bold' }" (click)="api.downloadFile(err.download)">{{err.short}}</a>
                        </td>
                        <td *ngIf="err.link" title="{{err.description}}" [ngStyle]="{ 'background-color': err.color || '#c33' }">
                          <a [routerLink]="['/pages/erp/document/' + data.getIssuerFromCode(err.link)]" [queryParams]="{ code: err.link}" [ngStyle]="{ 'color': err.textColor || 'white', 'font-weight': err.fontWeight || 'bold' }" target="_blank">{{err.short}}</a>
                        </td>
                      </ng-container>
                    </tr>
                  </table>
                  <!-- error2 header table -->
                  <table *ngIf="doc.errors2?.length" class="error-header">
                    <tr>
                      <ng-container *ngFor="let err of doc.errors2">
                        <td *ngIf="!err.link && !err.download" title="{{err.description}}" [ngStyle]="{ 'background-color': err.color || '#c33', 'color': err.textColor || 'white', 'font-weight': err.fontWeight || 'bold' }">{{err.short}}</td>
                        <td *ngIf="err.download" title="{{err.description}}" [ngStyle]="{ 'background-color': err.color || '#c33' }">
                          <a [routerLink]="[]" [ngStyle]="{ 'font-weight': err.fontWeight || 'bold' }" (click)="api.downloadFile(err.download)">{{err.short}}</a>
                        </td>
                        <td *ngIf="err.link" title="{{err.description}}" [ngStyle]="{ 'background-color': err.color || '#c33' }">
                          <a [routerLink]="['/pages/erp/document/' + data.getIssuerFromCode(err.link)]" [queryParams]="{ code: err.link}" [ngStyle]="{ 'color': err.textColor || 'white', 'font-weight': err.fontWeight || 'bold' }" target="_blank">{{err.short}}</a>
                        </td>
                      </ng-container>
                    </tr>
                  </table>
                  <!-- header text -->
                   <div *ngIf="doc.headerText?.length" style="margin:2pt;padding:2pt 4pt;border:1pt solid #eee">
                    {{doc.headerText}}
                   </div>
                  <!-- document table -->
                  <table class="doc-item-header">
                    <tr><!-- headers -->
                      <td style="width:1rem;text-align:right;padding:0"></td>
                      <ng-container *ngFor="let item of getPdfTable(doc).docTable">
                        <td class="product-header" [ngStyle]="{ 'text-align': item.align || 'inherit', width: item.width || 'auto' }">{{item.header}}</td>
                      </ng-container>
                    </tr>
                    <tr> <!-- data -->
                      <td style="width:1rem;text-align:right;padding:0">{{getDocIndex(doc, docidx)}}</td>
                      <ng-container *ngFor="let item of getPdfTable(doc).docTable">
                        <td [ngStyle]="{ 'text-align': item.align || 'inherit', width: item.width || 'auto' }" [style.background-color]="getBackgroundColor(doc, item)">
                          <ng-container *ngIf="!item.href">{{getValue(doc, item.name)}}</ng-container>
                          <ng-container *ngIf="item.href && getValue(doc, item.name) as val">
                            <a
                              class="doc-num-link"
                              [href]="'#/pages/erp/document/' + val[2] + '?code=' + val[1]"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {{ val[0] }}
                            </a>
                          </ng-container>
                        </td>
                      </ng-container>
                    </tr>
                    <ng-container *ngIf="getPdfTable(doc).docTable2 && (getPdfTable(doc).productExtra.docs ? getPdfTable(doc).productExtra.docs.test(doc.code) : true)"> <!-- second line -->
                      <ng-container *ngFor="let docTable2 of getPdfTable(doc).docTable2">
                        <tr *ngIf="getDocTable2ItemCount(doc, docTable2)">
                          <td [attr.colspan]="getPdfTable(doc).docTable.length+1">
                            <div style="margin-top:0.6rem;width:auto;margin-left:2rem;border: 1pt solid #eee">
                              <!-- <tr> -->
                                <ng-container *ngFor="let item of docTable2">
                                  <!-- <td *ngIf="getValue(doc, item.data.name)" -->
                                  <div *ngIf="getValue(doc, item.data.name)"
                                  [ngStyle]="{
                                    'min-width': getDocTable2ItemCount(doc, docTable2) > 10 ? '6em' : '6.5em', 
                                    'padding': getDocTable2ItemCount(doc, docTable2) > 10 ? '0' : '0 0.4rem', 
                                    'white-space': 'pre-wrap', 
                                    'text-align': item.data.align ?? 'left',
                                    'display': 'inline-block'
                                  }">
                                  <!-- <td *ngIf="getValue(doc, item.data.name)" class="product-header" [ngStyle]="{ width: item.label.width || 'auto' }">{{item.label.text}}</td>
                                  <td [ngStyle]="{ 'text-align': item.data.align || 'inherit', width: item.data.width || 'auto' }" [style.background-color]="getBackgroundColor(doc, item.data)">
                                    {{getValue(doc, item.data.name)}} -->
                                    <div class="product-header" [ngStyle]="{ padding: 0, width: item.label.width || 'auto' }">
                                      <!-- *{{item.data.name}}* -->
                                      <span *ngIf="doc.erpDate?.[item.data.field ?? item.data.name]?.history?.length" class="print-hidden" style="font-size:5pt;color:#77d;border:1px solid; border-radius:50%;padding: 0 1px;margin-right:1px">H</span>{{item.label.text}}
                                    </div>
                                    <!-- <div 
                                      [ngStyle]="{ width: item.data.width || 'auto' }" 
                                      [style.background-color]="getBackgroundColor(doc, item.data)"
                                      [style.font-size]="getDocTable2ItemCount(doc, docTable2) > 10 ? '0.85em' : '1em'"
                                      [style.white-space]="'nowrap'"
                                      >
                                      <ng-container>{{getValue(doc, item.data.name)}}</ng-container>
                                    </div> -->
                                    <!-- *************{{item.data.name}}-{{doc?.erpDate?.[item.data.name]?.history?.length}} -->
                                    <div 
                                      [ngStyle]="{ width: item.data.width || 'auto', 'border-radius': '3px', 'padding': '0 0.2rem' }" 
                                      [style.background-color]="getBackgroundColor(doc, item.data)"
                                      [style.font-size]="getDocTable2ItemCount(doc, docTable2) > 10 ? '0.85em' : '1em'"
                                      [style.border]="item.data.name === nextInvoiceDateMap(doc.nextInvoiceDateRef) && '1pt solid #ace'"
                                      >
                                      <div *ngIf="doc.erpDate?.[item.data.field ?? item.data.name]?.history?.length" 
                                        [nbPopover]="dateHistory" 
                                        nbPopoverTrigger="hover"
                                        style="cursor: pointer;display:inline-block"
                                        >
                                        <ng-container>{{getValue(doc, item.data.name)}}</ng-container>
                                      </div>
                                      <ng-container *ngIf="!doc.erpDate?.[item.data.field ?? item.data.name]?.history?.length">{{getValue(doc, item.data.name)}}</ng-container>
                                      <div 
                                        *ngIf="item.data.name === 'expectedNextInvoiceDate'" 
                                        style="display:inline-block;padding:0 0.2rem;margin-left:0.2rem;border:1pt solid #ace;border-radius:4px;font-size:0.9em;height:0.75rem"
                                        >
                                        <span *ngIf="!doc.nextInvoiceDateRef" title="custom">cust</span>
                                        <span *ngIf="doc.nextInvoiceDateRef" [title]="doc.nextInvoiceDateRef">ref&nwarr;</span>
                                      </div>
                                    </div>
                                  <!-- </td> -->
                                   </div>
                                    <ng-template #dateHistory>
                                      <div class="m-3">
                                        <b>Date History</b>
                                        <table class="nrk-table">
                                          <tr><th>Date</th><th>User</th><th>Remark</th><th>Updated At</th></tr>
                                          <tr *ngFor="let date of doc.erpDate?.[item.data.field ?? item.data.name].history">
                                            <td><b>{{date.val | date : "yy-MM-dd"}}</b></td>
                                            <td>{{date.user}}</td>
                                            <td>{{date.remark}}</td>
                                            <td style="font-size:smaller;color:gray;">{{date.updatedAt | date : "yy-MM-dd HH:mm"}}</td>
                                          </tr>
                                        </table>
                                      </div>
                                      <!-- <div class="m-3" *ngIf="!compilation.erpDate?.[field]?.history?.length">
                                        No date history present.
                                      </div> -->
                                    </ng-template>
                                </ng-container>
                              <!-- </tr> -->
                            </div>
                          </td>
                        </tr>  
                      </ng-container>
                    </ng-container>
                    <tr *ngIf="doc.nextMilestone">
                      <td [attr.colspan]="getPdfTable(doc).docTable.length+1">
                        <div style="width:auto;margin-left:2rem;border: 1pt solid #eee">
                          <table style="table-layout:auto;">
                            <tr><td class="product-header" style="white-space:nowrap;width:1%">
                              <span>Next Invoice Milestone:</span>
                            </td><td style="padding:0.2rem;white-space:pre-wrap;">                         
                              <span>{{doc.nextMilestone}}</span>
                              <span *ngIf="doc.nextMilestonePercent">&nbsp;&nbsp;&nbsp;[{{doc.nextMilestonePercent}}]</span>
                              <span *ngIf="doc.nextMilestoneValue">&nbsp;[{{doc.nextMilestoneValue}}]</span>
                            </td></tr>
                          </table>
                        </div>
                        <!-- <div style="display:-webkit-flex;display:flex;margin-left:2rem;border: 1px solid #eee;padding:0.2rem 0.3rem;-webkit-align-items:baseline;align-items:baseline;white-space:pre-wrap">
                          <div class="product-header" style="padding-right:0.5rem;float:left">Next Invoice Milestone:</div>
                          <div style="display:inline-block;">
                            <span>{{doc.nextMilestone}}</span>
                            <span *ngIf="doc.nextMilestonePercent">&nbsp;&nbsp;&nbsp;[{{doc.nextMilestonePercent}}]</span>
                            <span *ngIf="doc.nextMilestoneValue">&nbsp;[{{doc.nextMilestoneValue}}]</span>
                          </div>
                        </div> -->
                      </td>
                    </tr>
                    <tr *ngIf="doc.creditNoteReason"> <!-- credit note reason -->
                      <td [attr.colspan]="getPdfTable(doc).docTable.length+1">
                        <div class="credit-note" style="margin-top:0.6rem;margin-left:1.7rem">
                          <div><span class="product-header">Credit note reason:&nbsp;</span>&nbsp;{{doc.creditNoteReason}}</div>
                          <div><span class="product-header">Invoice:&nbsp;</span>&nbsp;{{doc.invoiceCode}}</div>
                          <div><span class="product-header">Net:&nbsp;</span>&nbsp;{{doc.invoiceNet | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</div>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="doc.extraText?.text">
                      <td [attr.colspan]="getPdfTable(doc).docTable.length+1">
                        <div style="width:auto;margin-left:2rem;border: 1pt solid #eee">
                          <table style="table-layout:auto;">
                            <tr><td class="product-header" style="white-space:nowrap;width:1%">
                              <span>{{doc.extraText.header}}</span>
                            </td><td style="padding:0.2rem;white-space:pre-wrap;">                        
                              <span>{{doc.extraText.text}}</span>
                            </td></tr>
                          </table>
                        </div>
                        <!-- <div style="display:-webkit-flex;display:flex;margin-left:2rem;border: 1px solid #eee;padding:0.2rem 0.3rem;-webkit-align-items:baseline;align-items:baseline;white-space:pre-wrap">
                          <div class="product-header" style="padding-right:0.5rem;float:left">{{doc.extraText.header}}</div>
                          <div style="display:inline-block">
                            <span>{{doc.extraText.text}}</span>
                          </div>
                        </div> -->
                      </td>
                    </tr>
                    <tr *ngIf="doc.extraText2?.text">
                      <td [attr.colspan]="getPdfTable(doc).docTable.length+1">
                        <div style="width:auto;margin-left:2rem;border: 1pt solid #eee">
                          <table style="table-layout:auto;">
                            <tr><td class="product-header" style="white-space:nowrap;width:1%">
                              <span>{{doc.extraText2.header}}</span>
                            </td><td style="padding:0.2rem;white-space:pre-wrap;">
                              <span>{{doc.extraText2.text}}</span>
                            </td></tr>
                          </table>
                        </div>  
                        <!-- <div style="display:-webkit-flex;display:flex;margin-left:2rem;border: 1px solid #eee;padding:0.2rem 0.3rem;-webkit-align-items:baseline;align-items:baseline;white-space:pre-wrap">
                          <div class="product-header" style="padding-right:0.5rem;float:left"></div>
                          <div style="display:inline-block">
                            <span>{{doc.extraText2.text}}</span>
                          </div>
                        </div> -->
                      </td>
                    </tr>
                    <tr *ngIf="doc.projectRemark?.items?.length && doc.projectRemark?.inProjectReport">
                      <td [attr.colspan]="getPdfTable(doc).docTable.length+1">
                        <div style="width:auto;margin-left:2rem;border: 1pt solid #eee">
                          <table style="table-layout:auto;">
                            <tr><td class="product-header" style="white-space:nowrap;width:1%">
                              <span>Project Remarks:</span>
                            </td><td style="padding:0.2rem;white-space:pre-wrap;">
                              <table style="table-layout:auto">
                                <tr  *ngFor="let item of filterRemarks(doc.projectRemark)">
                                  <td style="white-space:nowrap;width:1%">{{item.date | date : 'yyMMdd'}}</td>
                                  <td style="white-space:nowrap;width:1%">({{item.user}})</td>
                                  <td>{{item.category}}</td>
                                  <td>{{item.text}}</td>
                                </tr>
                              </table>
                            </td></tr>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div *ngIf="showButtons" style="position:relative"><div style="position: absolute; right: -7em"><button class="nrk-button" (click)="popupOrderReport(doc)">OR report</button></div></div>

                  <!-- product table -->
                  <table>
                    <tr>

                      <!-- extra table -->
                      <td *ngIf="getPdfTable().extra" class="extra-table" [style.width]="getPdfTable().extra.width.table" [attr.rowspan]="doc.lineItems?.length*2 + 1">
                        <table>
                          <tr *ngFor="let ei of getPdfTable().extra.table">
                            <ng-container *ngFor="let col of ei; index as idx">
                              <td class="product-header" [style.width]="getPdfTable().extra.width.cols[idx].header">{{col.header}}</td>
                              <td [style.width]="getPdfTable().extra.width.cols[idx].value">{{getValue(doc, col.name)}}</td>
                            </ng-container>
                          </tr>
                        </table>
                      </td>

                      <!-- warning / info marks --><!-- legacy -->
                      <!-- <td *ngIf="doc.dispatchDateUnconfirmed || doc.customerAccDate < doc.vieDispatchDate || doc.arrivalDate > doc.vieDispatchDate" style="width:0px !important" [attr.rowspan]="doc.lineItems?.length*2 + 1">
                        <div style ="position:relative">
                          <div style="position:absolute;display:flex;justify-content:center;align-items:center;width:2em;">
                            <div style="text-align: center">
                              <span *ngIf="doc.customerAccDate < doc.vieDispatchDate" class="exclamation">!</span>
                              <span *ngIf="doc.arrivalDate > doc.vieDispatchDate" class="exclamation">!!</span>
                              <div style="text-align:center;border:1px solid black;margin:-7px 1px;padding:0 2px;" *ngIf="doc.dispatchDateUnconfirmed"><b>NC</b></div>
                            </div>
                          </div>
                        </div>
                      </td> -->

                      <td style="width:1rem;"></td><td style="width:1rem;text-align:center"></td>

                      <!-- product table headers -->
                      <ng-container *ngFor="let item of getPdfTable().productTable">
                        <td *ngIf="showProductTableItem(item, doc)" class="product-header" [ngStyle]="{ 'text-align': item.align || 'inherit', width: item.width || 'auto', 'vertical-align': 'bottom' }">{{item.header}}</td>
                      </ng-container>
                    </tr>

                    <!-- line items -->

                    <ng-container *ngFor="let product of doc.lineItems; index as prodidx">
                      <tr class="product-item">
                        <td style="width:1rem;"></td><td style="width:1rem;text-align:center;color:gray;font-size:smaller">
                          <div class="metrics-link" (click)="openMetrics(doc, prodidx)">{{prodidx+1}}</div></td>
                        <ng-container *ngFor="let item of getPdfTable().productTable">
                          <td *ngIf="showProductTableItem(item, doc)" [ngStyle]="{ 'text-align': item.align || 'inherit', width: item.width || 'auto', backgroundColor: quantityColor(product, item.name) }">
                            <span>{{getValue(product, item.name, true)}}</span>
                          </td>
                        </ng-container>
                      </tr>
                      <tr>
                        <td></td><td></td>

                        <!-- product (line item) extra table -->
                        <td [attr.colspan]="doc.colspan ?? getPdfTable().productTable.length"  *ngIf="product.extra?.length"><div class="product-extra">
                          <table>
                            <ng-container *ngFor="let extra of product.extra; index as idx; last as isLast">
                              <tr *ngIf="idx === 0">
                                <ng-container *ngFor="let item of getPdfTable().productExtra?.table">
                                  <td td class="product-header" [ngStyle]="{ 'text-align': item.align || 'inherit', width: item.width || 'auto' }">{{item.header}}</td>
                                </ng-container>
                              </tr>
                              <!-- error header table -->
                              <tr *ngIf="extra?.errors?.length"><td>
                                <table class="error-header">
                                  <tr>
                                    <td *ngFor="let err of extra.errors" title="{{err.description}}" [ngStyle]="{ 'background-color': err.color ? err.color : '#c33' }">{{err.short}}</td>
                                  </tr>
                                </table>
                              </td></tr>
                              <!-- error2 header table -->
                              <tr *ngIf="extra?.errors2?.length"><td>
                                <table class="error-header">
                                  <tr>
                                    <td *ngFor="let err of extra.errors2" title="{{err.description}}" [ngStyle]="{ 'background-color': err.color ? err.color : '#c33' }">{{err.short}}</td>
                                  </tr>
                                </table>
                              </td></tr>
                              <!-- extra text -->
                              <tr *ngIf="extra?.extraText"><td colspan="100">
                                <div style="margin:2pt 4pt;width:100%;padding:2pt;border: 1pt solid #ccc">
                                  {{extra.extraText}}
                                </div>
                              </td></tr>
<!--                              <tr *ngIf="getPdfTable().productExtra.docTable2"> <!~~ second line ~~>
                                <td [attr.colspan]="getPdfTable().productExtra.docTable2.length+1">
                                  <table style="margin-top:0.6rem;width:unset">
                                    <tr><td style="width:2rem"></td>
                                      <ng-container *ngFor="let item of getPdfTable().productExtra.docTable2">
                                        <td
                                        [ngStyle]="{'padding': 0, 'white-space': 'pre-wrap', 'text-align': item.data.align ?? 'left'}">
                                          bbb
                                          <div class="product-header" [ngStyle]="{ width: item.label.width || 'auto' }">{{item.label.text}}</div>
                                          <div 
                                            [ngStyle]="{ width: item.data.width || 'auto' }" 
                                            [style.font-size]="'6pt'"
                                            [style.white-space]="'nowrap'"
                                            >
                                            <ng-container>{{getValue(product, item.name, true, idx)}}</ng-container>
                                          </div>
                                        </td>
                                      </ng-container>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
-->                              <tr>
                                <ng-container *ngFor="let item of getPdfTable().productExtra?.table">
                                  <td [ngStyle]="{ 'text-align': item.align || 'inherit', width: item.width || 'auto', padding: '0 0.4rem' }" 
                                    [style.background-color]="getBackgroundColor(product, item, true, idx)"
                                    >
                                    <!-- {{getValue(product, item.name, true, idx)}} -->
                                    <!-- <ng-container *ngIf="!item.href">{{getValue(product, item.name, true, idx)}}</ng-container>
                                    <a class="doc-num-link" *ngIf="item.href" [routerLink]="['/pages/erp/document/' + getValue(product, item.name, true, idx)[2]]" 
                                      [queryParams]="{code: getValue(product, item.name, true, idx)[1]}" target="_blank">
                                      {{getValue(product, item.name, true, idx)[0]}}
                                    </a> -->
                                    <div *ngIf="!item.href" [ngStyle]="
                                      item.name === nextInvoiceDateMap(doc.nextInvoiceDateRef, true) 
                                      && { 'border': '1pt solid #ace', 'border-radius': '4px', 'width': '4rem' }"
                                      >{{getValue(product, item.name, true, idx)}}</div>
                                    <a
                                      class="doc-num-link"
                                      *ngIf="item.href"
                                      [href]="'#/pages/erp/document/' + getValue(product, item.name, true, idx)[2] + '?code=' + getValue(product, item.name, true, idx)[1]"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {{ getValue(product, item.name, true, idx)[0] }}
                                    </a>
                                  </td>
                                </ng-container>
                              </tr>
                              <tr *ngIf="isLast && (idx > 0 || product.quantity - getQuantity(product) < 0)">
                                <td [attr.colspan]="getPdfTable().productExtra?.table.length - 2"></td>
                                <td [ngStyle]="{ 'text-align': 'right', padding: '0 1rem', backgroundColor: quantityColor(product, 'lineItems.extra.quantity') }">
                                  Diff:&nbsp;&nbsp;{{product.quantity - getQuantity(product)}}
                                </td>
                                <td [ngStyle]="{ 'text-align': 'right', padding: '0 0.4rem', backgroundColor: quantityColor(product, 'lineItems.extra.quantity') }">
                                  {{getQuantity(product)}}
                                </td>
                              </tr>
                            </ng-container>
                          </table>
                        </div></td>

                      </tr>
                    </ng-container>

                    <!-- deductibles -->

                    <ng-container *ngFor="let deductible of doc.deductibleItems; index as deductibleidx">
                      <tr class="product-item">
                        <td style="width:1rem;"></td><td style="width:1rem;text-align:center;color:gray;font-size:smaller">{{doc.lineItems.length+deductibleidx+1}}</td>
                        <ng-container *ngFor="let item of getPdfTable().productTable; index as didx">
                          <td *ngIf="item.name == 'lineItems.productName'" [ngStyle]="{ 'text-align': item.align || 'inherit', width: item.width || 'auto' }">{{getValue(deductible, 'description')}}</td>
                          <td *ngIf="item.name == 'lineItems.net' && !query.noPrices" [ngStyle]="{ 'text-align': item.align || 'inherit', width: item.width || 'auto' }">{{getValue(deductible, 'value')}}</td>
                          <td *ngIf="item.name != 'lineItems.net' && item.name != 'lineItems.productName' && didx < getProductTableLength(doc) - 1"></td>
                        </ng-container>
                      </tr>
                    </ng-container>

                    <!-- progress payment invoices -->

                    <ng-container *ngFor="let ppInv of doc.progressPaymentInvoices; index as ppinvidx">
                      <tr class="product-item">
                        <td style="width:1rem;"></td><td style="width:1rem;text-align:center;color:gray;font-size:smaller">{{doc.lineItems.length+doc.deductibleItems.length+ppinvidx+1}}</td>
                        <ng-container *ngFor="let item of getPdfTable().productTable; index as didx">
                          <td *ngIf="item.name == 'lineItems.productName'" [ngStyle]="{ 'text-align': item.align || 'inherit', width: item.width || 'auto' }">{{ppInv.code}}, {{ppInv.issueDate | date : 'yyyy-MM-dd'}}</td>
                          <td *ngIf="item.name == 'lineItems.net' && !query.noPrices" [ngStyle]="{ 'text-align': item.align || 'inherit', width: item.width || 'auto' }">{{ppInv.net  | currency : doc.currency : 'symbol' : '1.2-2' : 'de' }}</td>
                          <td *ngIf="item.name != 'lineItems.net' && item.name != 'lineItems.productName' && didx < getProductTableLength(doc) - 1"></td>
                        </ng-container>
                      </tr>
                    </ng-container>
                                        
                    <!-- Net total -->

                    <tr *ngIf="(doc.lineItems?.length > 1 || doc.deductibleItems?.length > 0) && !query.noPrices" class="product-item product-total">
                      <td [attr.colspan]="getProductTableLength(doc) - 1"></td>
                      <td colspan="2">Net total:</td>
                      <td>{{getSubTotalNet(doc) | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                      <td *ngIf="getPdfTable().extra">{{getSubTotalKg(doc) | number : '1.2-2' : 'de' }} kg</td>
                    </tr>
                    <!-- <tr *ngIf="isMachinery() && (doc.lineItems?.length > 1 || doc.deductibleItems?.length > 0) && !query.noPrices && getSubtotalGross(doc)" class="product-item product-total">
                      <td [attr.colspan]="getProductTableLength(doc) + 1"></td>
                      <td>{{getSubtotalGross(doc) | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                      <td *ngIf="getPdfTable().extra"></td>
                    </tr>
                    <tr *ngIf="isMachinery() && (doc.lineItems?.length > 1 || doc.deductibleItems?.length > 0) && !query.noPrices && getSubtotalProgressPayment(doc)" class="product-item product-total">
                      <td [attr.colspan]="getProductTableLength(doc) + 1"></td>
                      <td>{{getSubtotalProgressPayment(doc) | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                      <td *ngIf="getPdfTable().extra"></td>
                    </tr> -->

                  </table>

                  <div *ngIf="showOfferData(docidx)">
                    <div>&nbsp;</div>
                    <table class="offerdata">
                      <tr>
                        <td style="width:3.65rem">Offer status:</td><td style="width:4rem">{{getOfferData(docidx, 'offerStatus')}}</td>
                        <!-- <td style="width:5.5rem">Status comment:</td><td style="width:13.5rem">{{getOfferData(docidx, 'statusComment')}}</td> -->
                        <td style="width:5rem">Offer comment:</td><td style="width:17rem">{{getOfferData(docidx, 'offerComment')}}</td>
                      </tr>
                    </table>
                    <table class="offerdata">
                      <tr>
                        <!-- <td style="width:4.2rem">Action point:</td><td style="width:11.2rem">{{getOfferData(docidx, 'actionPoint')}}</td> -->
                        <!-- <td style="width:3.5rem">Probability:</td><td style="width:4rem">{{getOfferData(docidx, 'probability')}}</td> -->
                        <!-- <td style="width:2.2rem">Share:</td><td style="width:4rem">{{getOfferData(docidx, 'share')}}</td> -->
                        <td style="width:3.1rem">Updated:</td><td style="width:5rem">{{getOfferData(docidx, 'updatedAt') | date : 'yyyy-MM-dd'}}</td>
                        <td style="width:3.1rem">By User:</td><td style="width:2rem">{{getOfferData(docidx, 'offerStatusUser')}}</td>
                        <td style="width:3.1rem">RFQ Ref:</td><td style="width:15rem">{{doc.rfqReference}}</td>
                        <ng-container *ngIf="doc.revision"><td style="width:3.2rem">Revision:</td><td>{{doc.revision}}</ng-container>
                        <td></td>
                      </tr>
                    </table>
                  </div>
            
                  <div *ngIf="search.orders?.showMarkup === 3 && getOcDataPerOr(docidx) && !query.noPrices" class="doc-item" style="font-style:italic;padding:0.5em;text-align:right">
                    <div>
                      Order confirmation net:<span style="display:inline-block;width:6rem;text-align:right">
                        {{ getOcDataPerOr(docidx).ocSum  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                      </span>
                    </div>
                    <div *ngIf="getOcDataPerOr(docidx).invSum">
                      Invoices net:<span style="display:inline-block;width:6rem;text-align:right">
                        {{ getOcDataPerOr(docidx).invSum  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                      </span>
                    </div>
                    <div *ngIf="getOcDataPerOr(docidx).cnSum">
                      Credit notes net:<span style="display:inline-block;width:6rem;text-align:right">
                        {{ getOcDataPerOr(docidx).cnSum  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                      </span>
                    </div>
                    <div *ngIf="getOcDataPerOr(docidx).cnSum">
                      IN-CN net:<span style="display:inline-block;width:6rem;text-align:right">
                        {{ getOcDataPerOr(docidx).invSum + getOcDataPerOr(docidx).cnSum  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                      </span>
                    </div>
                    <div *ngIf="getOcDataPerOr(docidx).spoSum">
                      (PF)SPO net:<span style="display:inline-block;width:6rem;text-align:right">
                        {{ getOcDataPerOr(docidx).spoSum  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                      </span>
                    </div>
                    <div *ngIf="getOcDataPerOr(docidx).spoSum">
                      Markup:<span style="display:inline-block;width:6rem;text-align:right">
                        {{ getOcDataPerOr(docidx).invSum + getOcDataPerOr(docidx).cnSum - getOcDataPerOr(docidx).spoSum  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                      </span>
                    </div>
                  </div>

                </div>
              </ng-container>

              <!-- TODO: readonly 
                <div *ngIf="showOrOcInvTotal(docidx) && /*!dashboard*/ && !query.noPrices" class="doc-item" style="font-style:italic;padding:0.5em;text-align:right">
              -->

              <div *ngIf="showOrOcInvTotal(docidx) && !query.noPrices && !isPopup" class="doc-item" style="font-style:italic;padding:0.5em;text-align:right">
                <div>
                  Order net:<span style="display:inline-block;width:6rem;text-align:right">
                    {{ getOrTotal(docidx)  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                  </span>
                </div>
                <div *ngIf="getOrOcTotal(docidx)">
                  Order confirmations net:<span style="display:inline-block;width:6rem;text-align:right">
                    {{ getOrOcTotal(docidx)  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                  </span>
                </div>
                <div *ngIf="getOrInvTotal(docidx)">
                  Invoices net:<span style="display:inline-block;width:6rem;text-align:right">
                    {{ getOrInvTotal(docidx)  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                  </span>
                </div>
                <div *ngIf="getOrCnTotal(docidx)">
                  Credit notes net:<span style="display:inline-block;width:6rem;text-align:right">
                    {{ getOrCnTotal(docidx)  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                  </span>
                </div>
                <div *ngIf="getOrCnTotal(docidx)">
                  IN-CN net:<span style="display:inline-block;width:6rem;text-align:right">
                    {{ getOrInvTotal(docidx) + getOrCnTotal(docidx)  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                  </span>
                </div>
                <div *ngIf="query?.showMarkup > 1 && getOrPfspoTotal(docidx)">
                  (PF)SPO net:<span style="display:inline-block;width:6rem;text-align:right">
                    {{ getOrPfspoTotal(docidx)  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                  </span>
                </div>
                <div *ngIf="query.showMarkup > 1 && getOrPfspoTotal(docidx)">
                  Markup:<span style="display:inline-block;width:6rem;text-align:right">
                    {{ getOrInvTotal(docidx) + getOrCnTotal(docidx) - getOrPfspoTotal(docidx)  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
                  </span>
                </div>
              </div>

              <br *ngIf="showDocFooter(docidx) && !dashboard">
              <!-- <br *ngIf="showDocFooter(docidx) && !dashboard && isMachinery()">
              <div *ngIf="showDocFooter(docidx) && !dashboard && !isMachinery()" class="section-total-net">
                Total net: {{ getSectionTotal(doc)  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}
              </div> -->
            </div>
          </div>
        </ng-container>

      </ng-container>

    </div>

  </div>



  <!-- *********************************************************** table for XLS / CSV preview ***************************************************************************  -->

  <div class="table-container" *ngIf="!pdfSidebar">
    <ngx-loading-spinner [loading]="loading"></ngx-loading-spinner>
    <div class="nodata hidden" *ngIf="xlsData == null || xlsData.table == null || xlsData.table.length === 0">
      <span *ngIf="!loading">no data available.</span>
      <span *ngIf="error">&nbsp;{{this.error}}</span>
    </div>

    <table class="xls-table" *ngIf="xlsData != null && xlsData.table != null && xlsData.table.length !== 0 && currentTable">
      <tr>
        <ng-container *ngFor="let col of currentTable">
          <th *ngIf="!col.hidden" [ngClass]="{'rightalign': col.align != null && col.align === 'right'}">{{col.header}}</th>
        </ng-container>
      </tr>
      <tr>
        <ng-container *ngFor="let col of currentTable; index as colidx">
          <th *ngIf="!col.hidden"><input type="text" [(ngModel)]="col.filter" (keyup)="xlsFilterChanged()"/></th>
        </ng-container>
      </tr>
      <tr *ngFor="let row of xlsData.displayTable; let ridx = index">
        <ng-container *ngFor="let col of currentTable; let cidx = index">
          <ng-container *ngIf="!$any(row).empty">


            <ng-container *ngIf="xlsData.displayTable[ridx][cidx]?.text">
              <td [ngStyle]="{ 'background-color' : xlsData.displayTable[ridx][cidx]?.color }">{{xlsData.displayTable[ridx][cidx].text}}</td>
            </ng-container>

            <ng-container *ngIf="!xlsData.displayTable[ridx][cidx]?.text">
              <td *ngIf="!col.hidden && !col.editable" [ngClass]="{'rightalign': currentTable[cidx] && currentTable[cidx].align && currentTable[cidx].align === 'right'}">
                <a *ngIf="['documentNumber', 'relatedCS'].includes(currentTable[cidx]?.name); else nohref" [href]="getLink(xlsData.displayTable[ridx][cidx])" target="_blank">{{getLink(xlsData.displayTable[ridx][cidx], true)}}</a>
                <ng-template #nohref><span>{{xlsData.displayTable[ridx][cidx]}}</span></ng-template>
              </td>
            </ng-container>

            <td *ngIf="col.editable">
              <div *ngIf="col.dueInfo && dueInfoPopupData[ridx]"><button class="nrk-button" (click)="dueInfoPopup.open()">Selection</button>
                <nrk-window #dueInfoPopup>
                  <nrk-header>Due Info</nrk-header>
                  <nrk-content>
                    <div style="padding:1rem;width:30rem">
                      <!-- <div class="mt-2">Due date
                        editmode::{{dueInfoPopupData[ridx].editMode}}::
                        <nb-radio-group name="dueInfoPopup" class="row col-md-8" [(ngModel)]="dueInfoPopupData[ridx].editMode" (ngModelChange)="dueInfoPopupData[ridx].dueText = $event ? '' : dueInfoData[ridx]?.[0]?.dueText || ''">
                          <nb-radio [value]="0" default>Add Mode</nb-radio>
                          <nb-radio [value]="1">Edit Mode</nb-radio>
                        </nb-radio-group>        
                      </div> -->
                      <div class="mt-2" *ngIf="dueInfoData[ridx]?.dueInfo?.length">Mode
                        <nb-radio-group name="'dueInfoPopup-' + ridx" class="row col-md-8" [(ngModel)]="dueInfoPopupData[ridx].editMode" (ngModelChange)="dueInfoPopupData[ridx].dueText = $event ? dueInfoData[ridx]?.[0]?.dueText || '' : ''">
                          <nb-radio [value]="false">Add Mode</nb-radio>
                          <nb-radio [value]="true">Edit Mode</nb-radio>
                        </nb-radio-group>        
                      </div>
                      <div class="mt-2">Due Date
                        <ngx-doc-form-date [(value)]="dueInfoPopupData[ridx].dueDate"></ngx-doc-form-date>
                      </div>
                      <div class="mt-2">Next IN DUE Date
                        <ngx-doc-form-date [(value)]="dueInfoPopupData[ridx].nextPaymentDate"></ngx-doc-form-date>
                      </div>
                      <div class="mt-2">
                        <ngx-doc-form-dropdown [(value)]="dueInfoPopupData[ridx].reminder" [options]="[
                            { id: '1st reminder', name: '1st reminder' },
                            { id: '2nd reminder', name: '2nd reminder' },
                            { id: '3rd reminder', name: '3rd reminder' },
                            { id: '4th reminder', name: '4th reminder' },
                          ]"></ngx-doc-form-dropdown>
                        <ngx-doc-form-date [(value)]="dueInfoPopupData[ridx].reminderDate"></ngx-doc-form-date>
                      </div>
                      <div class="mt-2">
                        <div *ngIf="!dueInfoPopupData[ridx].editMode">{{ xlsData.map[ridx].dueInfo?.length ? dueInfoData[ridx]?.[0]?.dueText : xlsData.map[ridx].dueText }}</div>
                        <ngx-form-text [multiline]="10" [(value)]="dueInfoPopupData[ridx].dueText"></ngx-form-text>
                      </div>
                    </div>


                    <!-- <div style="padding:1rem;width:30rem">
                      <div class="mt-2">1st reminder
                        <ngx-doc-form-date [(value)]="dueInfoPopupData[ridx].reminder1"></ngx-doc-form-date>
                      </div>
                      <div class="mt-2">2nd reminder
                        <ngx-doc-form-date [(value)]="dueInfoPopupData[ridx].reminder2"></ngx-doc-form-date>
                      </div>
                      <div class="mt-2">3rd reminder
                        <ngx-doc-form-date [(value)]="dueInfoPopupData[ridx].reminder3"></ngx-doc-form-date>
                      </div>
                      <div class="mt-2">
                        <ngx-form-text [multiline]="10" [(value)]="dueInfoPopupData[ridx].text"></ngx-form-text>
                      </div>
                    </div> -->
                  </nrk-content>
                  <nrk-footer class="text-center">
                    <button class="mt-3 nrk-button" (click)="dueInfoChanged(row, ridx);dueInfoPopup.close()">submit</button>
                  </nrk-footer>
                  </nrk-window>
              </div>
              <div *ngIf="col.dueInfo && dueInfoData[ridx]?.length">
                <table class="nrk-table">
                  <tr><th>User</th><th>Due Date</th><th>Due text</th><th>Nxt IN Due Dt</th><th>Last Update</th></tr>
                  <tr *ngFor="let did of dueInfoData[ridx]">
                    <td>{{data.userShort(did.user)}}</td>
                    <td>{{(did.dueDate && (did.dueDate | date : 'yyyy-MM-dd')) || ''}}</td>
                    <td style="white-space:pre-wrap">{{did.dueText}}</td>
                    <td>{{( did.nextPaymentDate && (did.nextPaymentDate | date : 'yyyy-MM-dd')) || ''}}</td>
                    <td>{{( did.lastDueUpdate && (did.lastDueUpdate | date : 'yyyy-MM-dd')) || ''}}</td>
                  </tr>
                </table>
              </div>
              <ngx-doc-form-date *ngIf="col.date" [value]="xlsData.displayTable[ridx][cidx]" (valueChange)="xlsTableValueChanged(col, $event, ridx, cidx)"></ngx-doc-form-date>
              <ngx-form-text *ngIf="!col.date" [multiline]="1" [value]="xlsData.displayTable[ridx][cidx]" (focusLost)="xlsTableValueChanged(col, $event, ridx, cidx)"></ngx-form-text>
            </td>
          </ng-container>
          <td *ngIf="$any(row).empty"></td>
        </ng-container>
      </tr>
    </table>

  </div>

  <!-- footer -->

  <div class="doc-footer hidden" *ngIf="!dashboard && !warehousingPopup">
    <button *ngIf="!warehousing || showDocumentPreview" class="btn btn-default btn-lg" (click)="onClosePreview()">Back</button>
    <button class="btn btn-info btn-lg" (click)="onDownloadExcel()" *ngIf="!pdfSidebar">Download Excel</button>
    <button class="btn btn-info btn-lg" (click)="onGenerateProjectOverviews()" *ngIf="!pdfSidebar && getType() === 'projectoverview'">Project Overview PDFs</button>
    <button class="btn btn-info btn-lg" (click)="onCreateInventoryList()" *ngIf="!pdfSidebar && getType() === 'inventory'">Download Inventory List</button>
    <button class="btn btn-info btn-lg" (click)="onDownloadPdf()" *ngIf="pdfSidebar">Download PDF</button>
    <button class="btn btn-info btn-lg" style="min-width:9rem" (click)="reloadData(true, false)" [attr.disabled]="isReloadingData || null">
      <ng-container *ngIf="!isReloadingData">Reload Data</ng-container>
      <ng-container *ngIf="isReloadingData"><ngx-loading-spinner [loading]="isReloadingData" [small]="true" label=""></ngx-loading-spinner></ng-container>
    </button>
    <span *ngIf="warehousing" class="ml-3">Last update: {{lastUpdate | date : 'yyyy-MM-dd HH:mm:ss'}} ({{lastUpdateAgo}})</span>


    <div class="float-right d-inline-block mt-3 mr-3">
      <ng-container *ngIf="!pdfSidebar" style="text-align: center">
        <button class="nrk-button mr-4" (click)="xlsClearFilters()">clear filter</button>
        Page {{ xlsPage+1 }} / {{ pages }}
        <button class="nrk-button ml-3" (click)="setDisplayTable(-1)" [attr.disabled]="xlsPage == 0 || null"><b>≪</b></button>
        <button class="nrk-button ml-2 mr-4" (click)="setDisplayTable(+1)" [attr.disabled]="xlsPage == pages - 1 || null"><b>≫</b></button>
      </ng-container>
      <button class="nrk-doc-button" (click)="scaleView(transformScale / 1.15)">-</button>
      <button class="nrk-doc-button" (click)="scaleView(transformScale = 1.3)"><i class="ion-search"></i></button>
      <button class="nrk-doc-button" (click)="scaleView(transformScale * 1.15)">+</button>
    </div>
  </div>
</ng-container>

<!-- *********************************************************** document PDF preview ***************************************************************************  -->

<div *ngIf="showDocumentPreview || showDocumentPreviewHidden" class="preview" [ngStyle]="showDocumentPreviewHidden ? { 'position': 'absolute', 'top': 0, 'left': 0, 'display': 'none' } : {}">
  <ngx-document-printer
    #documentPrinter 
    [compilation]="compilation" 
    [userOptions]="$any(data.userOptions)"
    [deliveryConditions]="getSelected($any(compilation).deliveryConditions, $any(deliveryConditionOptions))"
    [taxHint]="getSelected(compilation.taxHint, $any(taxHintOptions))"
    [relatedDocuments]="$any(relatedDocuments)"
    [latestVersionItems]="data.latestVersionItems"
    (done)="onShowDocumentPreview(false)">
  </ngx-document-printer>
  <!-- [issuedBy]="getSelected($any(compilation).issuedBy, data.userOptions)" -->
</div>

<!-- ********************************************************* document PDF preview popup***************************************************************************  -->

<ng-container *ngIf="showPopupDocument" >
  <ngx-popup-document #popupDocument [compilation]="compilation" [warehousingPopup]="warehousing" [warehousingData]="warehousingData" (reloadData)="reloadData()" (close)="showPopupDocument=false;reloadData();">
  </ngx-popup-document>  
 </ng-container>



<div class="hidden">

  <!-- modify internal updates -->
  <ngx-internal-updates #internalUpdates [linked]="true" (updated)="reloadData(true, false)"></ngx-internal-updates>

  <!-- Message Window -->
  <ngx-messaging *ngIf="messaging" #messageWindow [messagingMode]="messagingMode.messageWindow" (close)="onMessagingClose($event)"></ngx-messaging>

  <nrk-window #docEditor>
    <nrk-header>Edit Dates {{docEditor?.data?.compilation?.code}}</nrk-header>
    <nrk-content *ngIf="docEditor?.data?.compilation">
      <ngx-report-dates #docEditorReportDates [compilation]="docEditor.data.compilation" [disabled]="false" [syncOnLoad]="true" (savedCSSPO)="onSaveCSSPO($event)"></ngx-report-dates>
      <div style="margin-bottom:15rem">&nbsp;</div>
    </nrk-content>
    <nrk-footer>
      <div class="text-center">
        <button class="nrk-button mr-4" (click)="saveDocEditor()">Save</button>
        <button class="nrk-button" (click)="docEditor.close()">Close</button>
      </div>
    </nrk-footer>
  </nrk-window>

  <!-- Offer Settings Window -->
  <nrk-window #offerSettingsWindow>
    <nrk-header><b>Offer Settings</b> {{currentOffer?.nameOverride || currentOffer?.code}}</nrk-header>
    <nrk-content *ngIf="currentOffer?.offerData">
      <div class="p-4 text-right pb-0">
        <a [routerLink]="[]" [nbPopover]="offerLegend">Offer Status Legend</a>
        <ng-template #offerLegend>
          <div class="p-4">
            <h5>Offer Status / Status Comment</h5>
            <ul>
              <ng-container *ngFor="let kv of offerStatus.getTable() | nrkKeyValue">
                <li [ngStyle]="{ 'background-color' : kv.value.color }">
                  <div>{{kv.key}}</div>
                  <div><ul>
                    <li *ngFor="let line of kv.value.stati">{{line}}</li>
                  </ul></div>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-template>
      </div>
      <ul style="list-style-type:none;padding:1rem">
        <ng-container *ngFor="let field of offerFields">
          <li [ngStyle]="{ width: field.value['type']==='percent' ? '6.5em' : null, 'padding-bottom' : '1rem' }">
            <div><label style="margin:0">{{field.value['label']}}</label></div>
            <div *ngIf="field.value['type']==='actionPoint'" class="fullwidth">
              <ngx-doc-form-dropdown [(value)]="currentOffer.offerData[field.key]"
                [options]="actionPointOptions"></ngx-doc-form-dropdown>
            </div>
            <div *ngIf="field.value['type']==='offerStatus'" class="fullwidth">
              <ngx-doc-form-dropdown [(value)]="currentOffer.offerData[field.key]" (valueChange)="offerStatusChanged()" [options]="offerStatusOptions"></ngx-doc-form-dropdown>
            </div>
            <div *ngIf="field.value['type']==='statusComment'" class="fullwidth">
              <ngx-doc-form-dropdown [styles]="{width:'21em'}" [(value)]="currentOffer.offerData[field.key]" [options]="statusCommentOptions"></ngx-doc-form-dropdown>
            </div>
            <div *ngIf="field.value['type']==='text'">
              <ngx-doc-form-texfield [styles]="{width:'25em'}" class="fullwidth" [(value)]="currentOffer.offerData[field.key]"></ngx-doc-form-texfield>
            </div>
            <div *ngIf="field.value['type']==='checkbox'">
              <ngx-doc-form-checkbox [(value)]="currentOffer.offerData[field.key]"></ngx-doc-form-checkbox>
            </div>
            <ngx-doc-form-dropdown *ngIf="field.value['type']==='percent'" [styles]="{width:'5em'}" class="fullwidth" 
              [(value)]="currentOffer.offerData[field.key]"[options]="percentOptions"></ngx-doc-form-dropdown>
            <!-- <nb-radio-group *ngIf="field.value['type'] === 'businessStatus'" name="businessStatus" [(ngModel)]="currentOffer.offerData[field.key]" style="display:inline-flex">
              <nb-radio [value]="undefined">undefined</nb-radio>
              <nb-radio [value]="11">New Business</nb-radio>
              <nb-radio [value]="12">Active Business</nb-radio>
            </nb-radio-group> -->
          </li>
        </ng-container>
      </ul>
    </nrk-content>
    <nrk-footer>
      <div class="text-center">
        <button class="nrk-button mr-4" (click)="saveOfferSettings();offerSettingsWindow.close()">Save</button>
        <button class="nrk-button" (click)="offerSettingsWindow.close()">Close</button>
      </div>
    </nrk-footer>
  </nrk-window>

  <!-- Due Info Data -->
  <nrk-window #dueInfoWin>
    <nrk-header><b>Due Info</b> {{currentDueInfoCode}}</nrk-header>
    <nrk-content>
      <div *ngIf="dueInfoData[currentDueInfoCode]" style="min-height:23rem">
        <table class="nrk-table">
          <tr><th><button class="nrk-doc-button" (click)="addDueinfoItem()">+</button></th><th>User</th><th>Due Date</th><th>New Payment Date</th><th>Due Info</th><th>Last Update</th></tr>
          <tr>
            <td></td>
            <td>{{data.userShort(dueInfoData[currentDueInfoCode].dueUser)}}</td>
            <td>
              <ngx-doc-form-date [(value)]="dueInfoData[currentDueInfoCode].dueDate"></ngx-doc-form-date>
            </td>
            <td>
              <ngx-doc-form-date [(value)]="dueInfoData[currentDueInfoCode].nextPaymentDate"></ngx-doc-form-date>
            </td>
            <td>
              <ngx-form-text [multiline]="1" [(value)]="dueInfoData[currentDueInfoCode].text"></ngx-form-text>
            </td>
            <td></td>
          </tr>
          <tr><td colspan="3">History:</td></tr>
          <tr *ngFor="let did of dueInfoData[currentDueInfoCode].info">
            <td></td>
            <td>{{data.userShort(did.user)}}</td>
            <td>{{(did.dueDate && (did.dueDate | date : 'yyyy-MM-dd')) || ''}}</td>
            <td>{{(did.nextPaymentDate && (did.nextPaymentDate | date : 'yyyy-MM-dd')) || ''}}</td>
            <td style="white-space:pre-wrap">{{did.dueText}}</td>
            <td>{{(did.lastDueUpdate && (did.lastDueUpdate | date : 'yyyy-MM-dd')) || ''}}</td>
          </tr>
        </table>
      </div>
    </nrk-content>
    <nrk-footer>
      <button class="nrk-button" (click)="dueInfoWin.close()">Close</button>
      <button class="nrk-button ml-4" (click)="saveCurrentDueInfo();dueInfoWin.close()">Save</button>
    </nrk-footer>
  </nrk-window>

</div>


<!-- <nrk-window #messageWindow>
  <nrk-header>Message</nrk-header>
  <nrk-content *ngIf="currentMessage">
    <div class="message-window">
      <p>
        <i style="display:inline-block;width:4rem">From:</i><b>{{ data.getOptionName(data.userOptions, currentMessage.user) }}</b><br>
        <i style="display:inline-block;width:4rem">To:</i><b>{{ (currentMessage.recipient && data.getOptionName(data.userOptions, currentMessage.recipient)) || 'All'}}</b><br>
        <i style="display:inline-block;width:4rem">At:</i>{{ currentMessage.timestamp | date : 'yyyy-MM-dd HH:mm' }}<br>
      </p>
      <p><i style="display:inline-block;width:4rem">Subject:</i><b class="pl-2">{{ currentMessage.subject }}</b></p>
      <p>{{ currentMessage.message }}</p>
    </div>
  </nrk-content>
  <nrk-footer>
    <div style="text-align:center">
      <button class="nrk-button mr-2" (click)="markMessageAsRead(currentMessage)">Mark as Read</button>
      <button class="nrk-button ml-2" (click)="messageWindow.hide()">Close</button>
    </div>
  </nrk-footer>
</nrk-window> -->

<ng-template #inventory>
  <h3 class="inventory-title">{{headerText}} Inventory Box List</h3>

  <ng-container *ngFor="let product of inventoryPdfData.rows | nrkKeyValue">

    <div class="inventory">

      <div class="hidden" style="margin-top:2rem">&nbsp;</div>

      <div class="header">
        <div>{{product.value[0].spoCountry}}</div>
        <div>{{product.value[0].spoCustomerReference}}</div>
        <div>{{product.value[0].spoCalcName}}; {{product.value[0].spoDimensions}} ({{product.value[0].spoCalcCode}}) - Total {{inventoryPdfData.totalCounts[$any(product.key)]}} pc</div>
      </div>

      <table>
        <tr><th *ngFor="let col of inventoryPdfData.columns">{{col.header}}</th></tr>
        <tr *ngFor="let row of $any(product.value)">
          <ng-container *ngFor="let col of inventoryPdfData.columns; last as isLast">
            <td *ngIf="!col.hidden"
              [ngStyle]="{ width: isLast ? null : col.width*0.6 + 'rem', 'text-align': col.alignment.horizontal }">{{getValue(row, col.key, true)}}</td>
          </ng-container>
        </tr>
      </table>
  
    </div>
  
  </ng-container>
  
</ng-template>


<!-- Profit margin / Project overview -->
<div class="hidden">
  <nrk-window #profitMarginWin>
    <nrk-header><b>Project Overviews</b></nrk-header>
    <nrk-content>
      <ng-container *ngFor="let profitMarginDoc of profitMarginDocs">
        <ngx-profit-margin #profitMargin [compilation]="profitMarginDoc" [type]="profitMarginType.ocSpo" [withWindow]="false"></ngx-profit-margin>
      </ng-container>
    </nrk-content>
    <nrk-footer>
      <div style="text-align:center">
        <button class="btn btn-sm btn-info" (click)="downloadProfitMargins()">Download</button>
      </div>
    </nrk-footer>
  </nrk-window>
</div>    